import { useContext } from 'react';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { getPageScope } from '../__helper/getChatBotConfig';
import { getCsCodeUpdateInfo } from '../__helper/getCsCodeUpdateInfo';
import { CsCodeUpdateResponse } from '../types';

export const useUpdateCsCode = () => {
    const { components } = useContext(CommunicationContext);

    const updateCsCode = async (csCode: string) => {
        const responseData = { apply_voucher: { success: false } };
        const updateInfo: CsCodeUpdateResponse = await getCsCodeUpdateInfo(
            csCode.trim()
        );
        const pageScope = getPageScope();

        if (updateInfo.status === 'success') {
            responseData.apply_voucher.success = true;

            if (
                updateInfo?.target === 'app' &&
                components.travel.appSplashScreen
            ) {
                components.travel.appSplashScreen.reOpen(csCode, false);
            }
            if (updateInfo.gratbar) {
                const gratBar = document.getElementById(
                    'info-point-bar-wrapper'
                );

                if (gratBar) {
                    gratBar.innerHTML = updateInfo.gratbar;
                }
            }
            if (updateInfo.csCode && pageScope === 5) {
                document.dispatchEvent(
                    new CustomEvent('voucher-update-with-new-code', {
                        detail: { code: csCode },
                    })
                );
            }
            if (
                updateInfo.isValidGhkCsCode &&
                components.travel.appSplashScreen
            ) {
                components.travel.appSplashScreen.setAppSplashScreenCookie();
            }
            if (pageScope !== 1 && pageScope !== 5) {
                document.dispatchEvent(
                    new CustomEvent('c24-travel-event-trigger-search')
                );
            }
        }

        return responseData;
    };

    return { updateCsCode };
};
